import React, { useEffect, useState } from 'react';
import Axios from 'axios';
import { useMediaQuery } from 'react-responsive';
import CollectionContent from './CollectionContent.jsx';
import ReactPlaceholder from 'react-placeholder';
import { TextRow, RectShape } from 'react-placeholder/lib/placeholders';
import { mergeDeep } from '../utils/mergeDeep.js'

export default function Collection(props) {
  const merchandisingTestActive = props.collection.metafields.settings && props.collection.metafields.settings.test_active;
  const desktopTestActive = props.collection.metafields.settings && props.collection.metafields.settings.desktop_test_active;
  const [collectionData, setCollectionData] = useState({
    data: props.desktop_collection || props.collection,
    loaded: desktopTestActive ? false : props.desktop_collection || false
  });
  const collectionHandle = desktopTestActive ? false : props.collection.metafields.settings && props.collection.metafields.settings.desktop_collection;
  const [desktopCollectionHandle, setDesktopCollectionHandle] = useState(collectionHandle);
  const isDesktop = useMediaQuery({ minWidth: 720 });
  const [monetateLoaded, setMonetateLoaded] = useState(false);

  const columnCount = props.collection.metafields.settings && parseInt(props.collection.metafields.settings.columns) || 3;

  let cName = `product-list row-of-${columnCount}`, sidebarPlaceholder = null;
  if (props.collection.sidebar && props.collection.sidebar.links && props.collection.sidebar.links.length) {
    cName += ' product-list-withsidebar';
    sidebarPlaceholder = <aside className="product-list-sidebar">
      <TextRow color="#f6f6f6" />
      <TextRow color="#f6f6f6" />
      <TextRow color="#f6f6f6" />
      <TextRow color="#f6f6f6" />
      <TextRow color="#f6f6f6" />
      <TextRow color="#f6f6f6" />
      <TextRow color="#f6f6f6" />
      <TextRow color="#f6f6f6" />
      <TextRow color="#f6f6f6" />
      <TextRow color="#f6f6f6" />
    </aside>
  }

  const numberOfRows = Math.ceil(props.collection.products.length / 2);
  const CollectionPlaceholder = (
    <div className="content-area collection-content">
      {sidebarPlaceholder}
      <div className={`${cName} products-wrap`}>
        <RectShape className="collection-title-header" color="#f6f6f6" style={{ height: 0, paddingBottom: "31.77%", marginRight: '' }} />
        <section className="product-group">
          {[...Array(numberOfRows)].map((e, i) => {
            return <ul className="products" key={i}>
              {[...Array(columnCount)].map((e, j) => {
                return <RectShape key={j} className="product" color="#f6f6f6" style={{ height: '', width: '', marginRight: '' }} />
              })}
            </ul>
          })}
        </section>
      </div>
    </div>
  );

  useEffect(() => {
    if (isDesktop && desktopCollectionHandle && !collectionData.loaded) {
      if (desktopCollectionHandle !== props.collection.handle) {
        Axios.get(`/collections/${desktopCollectionHandle}?view=_json_data`).then(response => {
          const parser = new DOMParser();
          const res = parser.parseFromString(response.data, "text/html");
          const data = JSON.parse(res.querySelector('[data-section-data]').innerHTML);
          setCollectionData({ data: data.collection, loaded: true });
        });
      } else {
        setCollectionData({ data: props.collection, loaded: true });
      }
    }
  }, [isDesktop, desktopCollectionHandle])

  const getCustomExperience = (experienceKey, experienceTimeout) => {
    if (window.customExperiences && window.customExperiences[experienceKey]) {
      if (experienceKey === 'collection') {
        const { products, ...data } = window.customExperiences[experienceKey];
        if (products) {
          Object.keys(products).forEach(key => {
            const product = collectionData.data.products.find(product => product.handle === key);
            mergeDeep(product, products[key])
          })
        }
        setCollectionData({ data: mergeDeep(collectionData.data, data) })
        return
      }
      setDesktopCollectionHandle(window.customExperiences[experienceKey]);
      clearTimeout(experienceTimeout);
    }
  }

  useEffect(() => {
    if (desktopTestActive) {
      const collectionHandleFallback = setTimeout(() => {
        setDesktopCollectionHandle(props.collection.metafields.settings.desktop_collection);
      }, 5000)
      getCustomExperience('desktopHandle', collectionHandleFallback);
      window.addEventListener('MonetateUpdated', () => {
        getCustomExperience('desktopHandle', collectionHandleFallback);
      });
      window.addEventListener('MonetateNotLoaded', () => {
        setDesktopCollectionHandle(props.collection.metafields.settings.desktop_collection);
        clearTimeout(collectionHandleFallback);
      });
      return;
    };
    if (merchandisingTestActive) {
      const fallback = setTimeout(() => {
        setMonetateLoaded(true);
      }, 5000)
      getCustomExperience('collection', fallback);
      window.addEventListener('MonetateUpdated', () => {
        getCustomExperience('collection', fallback);
        setMonetateLoaded(true);
      });
      window.addEventListener('MonetateNotLoaded', () => {
        setMonetateLoaded(true);
        clearTimeout(fallback);
      });
    }
  }, [])

  if (isDesktop && (desktopCollectionHandle || desktopTestActive)) {
    return <ReactPlaceholder customPlaceholder={CollectionPlaceholder} ready={collectionData.loaded} showLoadingAnimation={false}>
      <CollectionContent {...collectionData.data} />
    </ReactPlaceholder>
  } else {
    return <ReactPlaceholder customPlaceholder={CollectionPlaceholder} ready={!merchandisingTestActive || monetateLoaded} showLoadingAnimation={false}>
      <CollectionContent {...collectionData.data} />
    </ReactPlaceholder>
  }
}